import { Serializable } from "./base";
import { WeeklyTripSheet } from "./weekly-trip-sheet";

export class GenerateWeeklyTripSheetResponse
  implements Serializable<GenerateWeeklyTripSheetResponse> {
  public status: boolean;
  public message: string;
  public result: WeeklyTripSheet;

  constructor() {}

  deserialize(input) {
    this.status = input.status;
    this.message = input.message;
    if (input.result) {
      this.result = new WeeklyTripSheet().deserialize(input.result);
    }

    return this;
  }
}
